import { dayjs } from 'element-plus'

export const formatUsdt = (value: number) => `${value / 1000000} USDT`

export const formatRub = (value: number) => `${Math.floor(value * 100) / 100} RUB`

export const dateTimeFormatter = (row: unknown, column: unknown, value: string) => dayjs(value).format('DD.MM.YYYY HH:mm:ss')
export const numberFormatter = (row: unknown, column: unknown, value: string) => value ? parseFloat(value).toLocaleString('ru-RU') : '0'

export const numberFormatterUSDT = (row: unknown, column: unknown, value: string) => {
  if (!value) return '0'

  const num = parseFloat(value)

  if (num >= 1000000000) {
    // Для миллиардов делим на 1 миллиард и округляем до 1 знака после запятой
    const formatted = (num / 1000000000).toLocaleString('ru-RU', {
      maximumFractionDigits: 1,
      minimumFractionDigits: 0
    })
    return formatted.replace(/,0$/, '') // Удаляем .0 если дробная часть 0
  } else if (num >= 1000000) {
    // Для миллионов делим на 1 миллион и выводим без дробной части
    return (num / 1000000).toLocaleString('ru-RU', {
      maximumFractionDigits: 0
    })
  } else {
    // Для чисел меньше миллиона просто форматируем
    return num.toLocaleString('ru-RU', {
      maximumFractionDigits: 0
    })
  }
}
